module.exports = __webpack_public_path__ + "img/logo_rmt-fond-blanc.2c41fd1f.jpg";